import Axios from "../api/axios";
import config from "../../config";

const getResponseLetter = () => {
  return Axios.get(`${config.BASE_URL}response-to-employer`);
};

export default getResponseLetter;
